/** Central query-key factory. Keep merchant-scoped resources grouped here. */
export const queryKeys = {
  session: {
    profile: (subject: string) => ["session", "profile", subject] as const,
  },
  billing: {
    root: ["billing"] as const,
    orderLists: ["billing", "orders"] as const,
    plans: ["billing", "plans"] as const,
    subscription: ["billing", "subscription"] as const,
    orders: (limit: number) => ["billing", "orders", { limit }] as const,
    order: (orderId: string | null | undefined) => ["billing", "order", orderId] as const,
    receiptProfile: ["billing", "receipt-profile"] as const,
  },
  channels: {
    all: ["channels"] as const,
  },
  conversations: {
    attention: ["conversations", "attention"] as const,
  },
  crm: {
    customerOrderLists: ["crm", "customer-orders"] as const,
    tags: ["crm", "tags"] as const,
    customerOrders: (customerId: string | null | undefined, limit?: number) =>
      ["crm", "customer-orders", customerId, { limit }] as const,
  },
  orders: {
    root: ["orders"] as const,
    lists: ["orders", "list"] as const,
    all: (filters: object) => ["orders", "list", filters] as const,
    detail: (orderId: string | null | undefined) => ["orders", "detail", orderId] as const,
    // Under `lists`, so creating or updating an order refreshes the chat thread too.
    conversation: (conversationId: string | null) => ["orders", "list", "conversation", conversationId] as const,
  },
  products: {
    root: ["products"] as const,
    lists: ["products", "list"] as const,
    all: (filters: object) => ["products", "list", filters] as const,
    detail: (productId: string | null | undefined) => ["products", "detail", productId] as const,
    categories: ["products", "categories"] as const,
  },
  settings: {
    ai: ["settings", "ai"] as const,
    aiUsage: ["settings", "ai", "usage"] as const,
    merchant: ["settings", "merchant"] as const,
  },
  team: {
    members: ["team", "members"] as const,
    invitations: ["team", "invitations"] as const,
  },
};
